import { gql } from '@apollo/client';

/* 订单列表分页查询；filter 为多维筛选入参，page 为 0-based（UI 传 page-1） */
export const GET_PORTAL_ORDERS = gql`
    query GetPortalOrders($filter: PortalOrderFilter, $page: Int, $size: Int) {
        portalOrders(filter: $filter, page: $page, size: $size) {
            content {
                trackingNumber
                channelOrderNumber
                externalTrackingNumber
                overallStatus
                externalStatus
                pickupHubName
                pickupAt
                sortingCode
                destHubArrivedAt
                orderTime
            }
            totalElements
            totalPages
            accessiblePages
            page
            size
        }
    }
`;

/* 包裹状态下拉选项；后端仅下发外部状态 code，label 由前端 i18n 渲染 */
export const GET_PORTAL_EXTERNAL_STATUSES = gql`
    query GetPortalExternalStatuses {
        portalExternalStatuses {
            code
        }
    }
`;

/* 订单详情查询；主键为 trackingNumber（后端全链路以 SWX 跟踪号为主键） */
export const GET_PORTAL_ORDER_DETAIL = gql`
    query GetPortalOrderDetail($trackingNumber: String!) {
        portalOrderDetail(trackingNumber: $trackingNumber) {
            trackingNumber
            channelOrderNumber
            externalTrackingNumber
            overallStatus
            externalStatus
            orderTime
            deliveredAt
            canceledAt
            returnedAt
            pickupAt
            senderAddress {
                fullName
                streetAddress
                addressLine2
                city
                stateProvince
                postalCode
            }
            recipientAddress {
                fullName
                streetAddress
                addressLine2
                city
                stateProvince
                postalCode
            }
            originalRecipientAddress {
                fullName
                streetAddress
                addressLine2
                city
                stateProvince
                postalCode
            }
            weightKg
            lengthCm
            widthCm
            heightCm
            volumetricWeightKg
            podInfo {
                photoUrls
            }
        }
    }
`;

/* 外部轨迹独立查询；详情有结果后再串行发起，localTime 原样展示不做时区转换 */
export const GET_PORTAL_ORDER_TRACKING = gql`
    query GetPortalOrderTracking($trackingNumber: String!) {
        portalOrderTracking(trackingNumber: $trackingNumber) {
            trackingNumber
            events {
                event
                description
                localTime
                localGmtOffset
                location
                iso3166Cc
                iso3166Sc
                cityUppercase
                postalCode
                podImageCount
            }
        }
    }
`;

/* 揽收口岸下拉 options（外部口岸）；externalPortCode 为筛选项 value，externalPortName 为展示文案 */
export const GET_PORTAL_PICKUP_HUB_OPTIONS = gql`
    query GetPortalPickupHubOptions {
        portalPickupHubOptions {
            externalPortCode
            externalPortName
        }
    }
`;
